import { useContext } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { ColorModeContext, tokens } from "../../theme";
import { Link, useParams } from "react-router-dom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
const LocationPath = ({ location }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const { id } = useParams();

  const homeLinkStyle = {
    color:
      colorMode === "dark" ? colors.greenAccent[900] : colors.greenAccent[100], // Change color based on color mode
    fontWeight: "bold",
    textDecoration: "none",
  };

  const iconStyle = {
    fontSize: "small",
    verticalAlign: "bottom",
    marginBottom: "4px",
    color:
      colorMode === "dark" ? colors.greenAccent[900] : colors.greenAccent[50], // Change color based on color mode
  };
  const getPageName = (location) => {
    switch (location.pathname) {
      case "/rptpl":
        return (
          <Link to="/rptpl" style={homeLinkStyle}>
            Home
          </Link>
        );
      case "/admin-dashboard":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> admin Dashboard
          </span>
        );
      case "/leads/sales":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Leads{" "}
            <FiberManualRecordIcon style={iconStyle} /> Sales
          </span>
        );
      case `/leads/sales/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Leads
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/leads/sales" style={homeLinkStyle}>
              Sales
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> profile
          </span>
        );
      case "/leads":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Leads
          </span>
        );
      case `/leads/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Leads
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/leads" style={homeLinkStyle}>
              Leads
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> profile
          </span>
        );
      case "/Users/Drivers":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Users{" "}
            <FiberManualRecordIcon style={iconStyle} /> Drivers
          </span>
        );
      case `/Users/Drivers/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Users{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/Users/Drivers" style={homeLinkStyle}>
              Driver
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> profile
          </span>
        );
      case "/Users/Fleet_Owners":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Users{" "}
            <FiberManualRecordIcon style={iconStyle} /> Fleet Owners
          </span>
        );
      case "/Users/Dhaba":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Users{" "}
            <FiberManualRecordIcon style={iconStyle} /> Dhaba
          </span>
        );
      case "/Users/mech_user":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Users{" "}
            <FiberManualRecordIcon style={iconStyle} /> Mechanic
          </span>
        );
      case "/Users/Crane_Owners":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Users{" "}
            <FiberManualRecordIcon style={iconStyle} /> Crane Owner
          </span>
        );
      case "/Users/Crane_Ope":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Users{" "}
            <FiberManualRecordIcon style={iconStyle} /> Crane Operators
          </span>
        );
      case "/Jobs/jobs":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Jobs{" "}
            <FiberManualRecordIcon style={iconStyle} /> Jobs
          </span>
        );

      case "/Jobs/applications":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Jobs{" "}
            <FiberManualRecordIcon style={iconStyle} /> Applicaions
          </span>
        );
      case "/hr/employees":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> HR{" "}
            <FiberManualRecordIcon style={iconStyle} /> Employees
          </span>
        );
      case `/hr/employees/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> HR{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/hr/employees" style={homeLinkStyle}>
              Employees
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Prof. Toni Swift
          </span>
        );
      case "/hr/leaves":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> HR{" "}
            <FiberManualRecordIcon style={iconStyle} /> Leaves
          </span>
        );
      case `/hr/leaves/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> HR{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/hr/leaves" style={homeLinkStyle}>
              Leave
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Prof. Toni Swift
          </span>
        );
      case "/hr/shift":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> HR{" "}
            <FiberManualRecordIcon style={iconStyle} /> Shift Roster
          </span>
        );

      case "/hr/attendance":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> HR{" "}
            <FiberManualRecordIcon style={iconStyle} /> Attendance
          </span>
        );
      case "/hr/holiday":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> HR{" "}
            <FiberManualRecordIcon style={iconStyle} /> Holiday
          </span>
        );

      case "/hr/designation":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> HR{" "}
            <FiberManualRecordIcon style={iconStyle} /> Designation
          </span>
        );
      case "/hr/department":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> HR{" "}
            <FiberManualRecordIcon style={iconStyle} /> Department
          </span>
        );

      case "/hr/appreciation":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> HR{" "}
            <FiberManualRecordIcon style={iconStyle} /> Appreciation
          </span>
        );
      case `/hr/appreciation/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> HR{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/hr/appreciation" style={homeLinkStyle}>
              Appreciation
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Prof Nani Singh
          </span>
        );
      case "/payroll/staff":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Payroll{" "}
            <FiberManualRecordIcon style={iconStyle} /> Staff
          </span>
        );
      case "/payroll/report":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Payroll{" "}
            <FiberManualRecordIcon style={iconStyle} /> Report
          </span>
        );

      case "/work/contracts":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Work{" "}
            <FiberManualRecordIcon style={iconStyle} /> Contract
          </span>
        );
      case "/work/projects":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Work{" "}
            <FiberManualRecordIcon style={iconStyle} /> Projects
          </span>
        );
      case "/work/tasks":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Work{" "}
            <FiberManualRecordIcon style={iconStyle} /> Tasks
          </span>
        );
      case "/work/time_sheet":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Work{" "}
            <FiberManualRecordIcon style={iconStyle} /> Time Sheet
          </span>
        );
      case `/work/time_sheet/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Work{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/work/time_sheet" style={homeLinkStyle}>
              Time Sheet
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            Details
          </span>
        );
      case "/finance/proposal":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Proposal
          </span>
        );
      case `/finance/proposal/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/finance/proposal" style={homeLinkStyle}>
              Proposal
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> {`Proposal#00${id}`}
          </span>
        );
      case "/finance/estimate":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Estimate
          </span>
        );
      case `/finance/estimate/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/finance/estimate" style={homeLinkStyle}>
              Estimate
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> {`Estimate#00${id}`}
          </span>
        );
      case "/finance/invoice":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Invoice
          </span>
        );
      case `/finance/invoice/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/finance/invoice" style={homeLinkStyle}>
              Invoices
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> {`INV#00${id}`}
          </span>
        );
      case "/finance/payments":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Payments
          </span>
        );
      case `/finance/payments/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/finance/payments" style={homeLinkStyle}>
              Payments
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Details
          </span>
        );
      case "/finance/credit":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Credit Note
          </span>
        );
      case "/finance/expenses":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Expenses
          </span>
        );
      case `/finance/expenses/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/finance/expenses" style={homeLinkStyle}>
              Expenses
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Details
          </span>
        );
      case "/finance/bank":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Bank Details
          </span>
        );
      case "/finance/settlements":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Settlements
          </span>
        );
      case "/finance/Wallet":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Wallet
          </span>
        );

      case "/assets":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Assets
          </span>
        );
      case `/assets/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/assets" style={homeLinkStyle}>
              Assets
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            Details
          </span>
        );
      case "/assets/products":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Assets{" "}
            <FiberManualRecordIcon style={iconStyle} /> Products
          </span>
        );

      case "/assets/orders":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Assets{" "}
            <FiberManualRecordIcon style={iconStyle} /> Prders
          </span>
        );

      case "/assets/vendor":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Assets{" "}
            <FiberManualRecordIcon style={iconStyle} /> Vendor
          </span>
        );

      case "/assets/purchase_order":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Assets{" "}
            <FiberManualRecordIcon style={iconStyle} /> Purchase Order
          </span>
        );

      case "/assets/bills":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Assets{" "}
            <FiberManualRecordIcon style={iconStyle} /> Bills
          </span>
        );

      case "/assets/vendor_payments":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Assets{" "}
            <FiberManualRecordIcon style={iconStyle} /> Vendor Payments
          </span>
        );

      case "/assets/vendor_credits":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Assets{" "}
            <FiberManualRecordIcon style={iconStyle} /> Vendor Credits
          </span>
        );

      case "/assets/Inventory":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Assets{" "}
            <FiberManualRecordIcon style={iconStyle} /> Inventory
          </span>
        );
      case "/assets/Report":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Assets{" "}
            <FiberManualRecordIcon style={iconStyle} /> Report
          </span>
        );

      case "/letter/generate":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Letter{" "}
            <FiberManualRecordIcon style={iconStyle} /> Generate
          </span>
        );
      case "/letter/templete":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Letter{" "}
            <FiberManualRecordIcon style={iconStyle} /> Templete
          </span>
        );

      case "/recruit/dashboard":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Recruit
            <FiberManualRecordIcon style={iconStyle} /> Dashboard
          </span>
        );
      case "/recruit/skills":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Recruit
            <FiberManualRecordIcon style={iconStyle} /> Skills
          </span>
        );

      case "/recruit/jobs":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Recruit
            <FiberManualRecordIcon style={iconStyle} /> Jobs
          </span>
        );
      case `/recruit/jobs/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Recruit
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/recruit/jobs" style={homeLinkStyle}>
              Jobs
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Details
          </span>
        );
      case "/recruit/applications":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Recruit
            <FiberManualRecordIcon style={iconStyle} /> Applications
          </span>
        );
      case `/recruit/applications/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Recruit
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/recruit/applications" style={homeLinkStyle}>
              Applications
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Details
          </span>
        );
      case "/recruit/interview":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Recruit
            <FiberManualRecordIcon style={iconStyle} /> Interview Schedule
          </span>
        );
      case "/recruit/site":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Recruit
            <FiberManualRecordIcon style={iconStyle} /> Career Site
          </span>
        );
      case "/recruit/candidates":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Recruit
            <FiberManualRecordIcon style={iconStyle} /> Candidates Database
          </span>
        );
      case "/recruit/offer":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Recruit
            <FiberManualRecordIcon style={iconStyle} /> Offer Letter
          </span>
        );
      case "/recruit/reports":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Recruit
            <FiberManualRecordIcon style={iconStyle} /> Reports
          </span>
        );

      case "/mettings/zoom":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Mettings{" "}
            <FiberManualRecordIcon style={iconStyle} />
            Zoom
          </span>
        );
      case "/mettings/Teams":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Mettings{" "}
            <FiberManualRecordIcon style={iconStyle} />
            Teams
          </span>
        );

      case "/mettings/jitsi":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Mettings{" "}
            <FiberManualRecordIcon style={iconStyle} />
            Jitsi
          </span>
        );

      case "/tickets":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Tickets
          </span>
        );
      case "/events":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Events
          </span>
        );

      case "/message":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> message
          </span>
        );
      case "/notice":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Notice Board
          </span>
        );
      case `/notice/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/notice" style={homeLinkStyle}>
              Notice Board
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            Profile
          </span>
        );
      case `/notice/${id}/edit`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/notice" style={homeLinkStyle}>
              Notice Board
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            Update
          </span>
        );
      case "/knowledge":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Knowledge Base
          </span>
        );
      case `/knowledge/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/knowledge" style={homeLinkStyle}>
              Knowledge Base
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            Profile
          </span>
        );

      case "/report/task":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Report{" "}
            <FiberManualRecordIcon style={iconStyle} /> Task Report
          </span>
        );
      case "/report/time_log":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Report{" "}
            <FiberManualRecordIcon style={iconStyle} /> Time Log Report
          </span>
        );

      case "/report/finance":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Report{" "}
            <FiberManualRecordIcon style={iconStyle} /> Finance Report
          </span>
        );

      case "/report/income":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Report{" "}
            <FiberManualRecordIcon style={iconStyle} /> Income Vs Expense
          </span>
        );

      case "/report/leave":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Report{" "}
            <FiberManualRecordIcon style={iconStyle} /> Leave Report
          </span>
        );

      case "/report/deal":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Report{" "}
            <FiberManualRecordIcon style={iconStyle} /> Deal Report
          </span>
        );

      case "/report/sales":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Report{" "}
            <FiberManualRecordIcon style={iconStyle} /> Sales Report
          </span>
        );

      case "/report/others":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Report{" "}
            <FiberManualRecordIcon style={iconStyle} /> Others Report
          </span>
        );

      case "/help":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Help
          </span>
        );

      case "/export":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Export
          </span>
        );
      case "/settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Settings
          </span>
        );
      case "/Business_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Business Settings
          </span>
        );
      case "/App_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> App Settings
          </span>
        );
      case "/Profile_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Profile Settings
          </span>
        );
      case "/tax_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Tax Settings
          </span>
        );
      case "/project_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Project Settings
          </span>
        );
      case "/rp_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Roles and Permission
          </span>
        );
      case "/Ticket_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Tickets Settings
          </span>
        );
      case "/Attendance_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Attendance Settings
          </span>
        );
      case "/Leads_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Leads Settings
          </span>
        );
      case "/Payroll_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Payroll Settings
          </span>
        );
      case "/Leave_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Leave Settings
          </span>
        );
      case "/time_log_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Time Log Settings
          </span>
        );
      case "/Task_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Task Settings
          </span>
        );
      case "/security_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Security Settings
          </span>
        );
      case "/purchase_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Purchase Settings
          </span>
        );
      case "/assets_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Assets Settings
          </span>
        );
      case "/recruit_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Recruit Settings
          </span>
        );
      case "/subscriptoin_settings":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/settings" style={homeLinkStyle}>
              Settings
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Subscription Settings
          </span>
        );
      case "/field_team":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> OnField Team
          </span>
        );
      case "/Convoy":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Convoy
          </span>
        );
      case "/membership":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Memberships
          </span>
        );
      case `/membership/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/membership" style={homeLinkStyle}>
              Memberships
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            {id}
          </span>
        );
      case "/driver/leave_requests":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Leave Requests
          </span>
        );
      case `/driver/leave_requests/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/driver/leave_requests" style={homeLinkStyle}>
              Leave Requests
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            {id}
          </span>
        );
      case "/driver/salary":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            Driver's Salary
          </span>
        );
      case `/driver/salary/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/driver/salary" style={homeLinkStyle}>
              Driver's Salary
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            Details
          </span>
        );
      case "/jobs/applications":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Job Applications
          </span>
        );
      case `/jobs/applications/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/jobs/applications" style={homeLinkStyle}>
              Job Applications
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            Details
          </span>
        );
      case "/jobs/created":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Vacancies Created
          </span>
        );
      case `/jobs/created/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/jobs/created" style={homeLinkStyle}>
              Vacancies Created
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            Details
          </span>
        );
      case "/clients":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Client
          </span>
        );
      case `/clients/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/clients" style={homeLinkStyle}>
              Clients
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            {id}
          </span>
        );
      case `/clients/driver/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/clients" style={homeLinkStyle}>
              Clients
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            {id}
            <FiberManualRecordIcon style={iconStyle} />
            profile
          </span>
        );

      case `/clients/driver/${id}/attendance`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/clients" style={homeLinkStyle}>
              Clients
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            {id}
            <FiberManualRecordIcon style={iconStyle} />
            attendance
          </span>
        );
      case "/crane_booking":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Crane Bookings
          </span>
        );
      case `/crane_booking/${id}`:
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            <Link to="/crane_booking" style={homeLinkStyle}>
              Crane Bookings
            </Link>
            <FiberManualRecordIcon style={iconStyle} />
            Details
          </span>
        );
      case "/App_Posts":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> App Posts
          </span>
        );
      case "/Vehicals_Data":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>
            <FiberManualRecordIcon style={iconStyle} /> Vehicals Data
          </span>
        );
      case "/appearance/blogs":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Appearance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Blogs
          </span>
        );
      case "/appearance/plans":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Appearance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Plans
          </span>
        );
      case "/appearance/services":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Appearance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Services
          </span>
        );
      case "/appearance/features":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Appearance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Features
          </span>
        );
      case "/appearance/faq":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Appearance{" "}
            <FiberManualRecordIcon style={iconStyle} /> FAQ
          </span>
        );
      case "/appearance/testimonials":
        return (
          <span>
            <Link to="/rptpl" style={homeLinkStyle}>
              Home
            </Link>{" "}
            <FiberManualRecordIcon style={iconStyle} /> Appearance{" "}
            <FiberManualRecordIcon style={iconStyle} /> Testimonials
          </span>
        );
      default:
        return "";
    }
  };
  return (
    <Box display="flex" variant="h1" fontWeight="bold" sx={{ mb: "5px" }}>
      <Typography>{getPageName(location)}</Typography>
    </Box>
  );
};

export default LocationPath;
